<template>
  <div v-if="canShare">
    <div class="s-full-article-container__text-wrapper_share-links">
      Share
      <ShareNetwork
        network="twitter"
        :url="url"
        :title="title"
        :description="description"
      >
        <img
          src="/images/icons/twitter_black.png"
          alt="twitter"
        />
      </ShareNetwork>

      <ShareNetwork
        network="facebook"
        :url="url"
        :title="title"
        :description="description"
      >
        <img
          src="/images/icons/facebook_black.png"
          alt="facebook"
        />
      </ShareNetwork>

      <ShareNetwork
        network="facebook"
        :url="url"
        :title="title"
        :description="description"
      >
        <img
          src="/images/icons/linkedin_black.png"
          alt="linkedin"
        />
      </ShareNetwork>

      <ShareNetwork
        network="facebook"
        :url="url"
        :title="title"
        :description="description"
      >
        <img
          src="/images/icons/instagram_black.png"
          alt="instagram"
        />
      </ShareNetwork>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ShareArticle',
    props: {
      title: {
        type: String,
        default: ''
      },
      content: {
        type: String,
        default: ''
      },

      article: {
        type: Object,
        default: null
      }
    },

    data() {
      return {
        truncSize: 197,
        networks: ['Facebook', 'Twitter', 'WhatsApp']
      }
    },

    computed: {
      canShare() {
        return !!this.title && !!this.content && !!this.article
      },

      description() {
        const noTags = this.content.replace(/(<([^>]+)>)/gi, '')
        if (noTags.length > this.truncSize) {
          return noTags.slice(0, this.truncSize) + '...'
        }

        return noTags
      },

      theTitle() {
        return this.title.replace(/(<([^>]+)>)/gi, '')
      },

      url() {
        return window.location.host + '/article?id=' + this.article?.id
      }
    }
  }
</script>

<style scoped lang="postcss">
  .menu {
    position: absolute;
    color: #d7d7d8;
    font-size: 20px;
    line-height: 1;
    font-weight: normal;
    width: 45px;
    margin-top: 2px;
  }

  .menu:before {
    content: '';
    transition: opacity 0.3s ease-in-out 0.6s, -webkit-transform 0.3s ease-in-out 0.3s;
    transition: transform 0.3s ease-in-out 0.3s, opacity 0.3s ease-in-out 0.6s;
    transition: transform 0.3s ease-in-out 0.3s, opacity 0.3s ease-in-out 0.6s, -webkit-transform 0.3s ease-in-out 0.3s;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
    opacity: 0;
    background: #fff;
    box-shadow: 0 0 5px #ccc;
    border-radius: 10px;
  }

  .menu__trigger {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    opacity: 0;
  }

  .menu__btn:hover .menu:before {
    transition: opacity 0.3s linear, -webkit-transform 0.3s ease-out 0.3s;
    transition: opacity 0.3s linear, transform 0.3s ease-out 0.3s;
    transition: opacity 0.3s linear, transform 0.3s ease-out 0.3s, -webkit-transform 0.3s ease-out 0.3s;
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    opacity: 1;
  }

  .menu__btn:hover .menu .menu__item {
    transition: opacity 0.3s linear, -webkit-transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out, opacity 0.3s linear;
    transition: transform 0.3s ease-in-out, opacity 0.3s linear, -webkit-transform 0.3s ease-in-out;
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
    opacity: 1;
  }

  .menu__btn:hover .menu .menu__item:nth-child(1) {
    transition-delay: 0.65s;
  }

  .menu__btn:hover .menu .menu__item:nth-child(2) {
    transition-delay: 0.6s;
  }

  .menu__btn:hover .menu .menu__item:nth-child(3) {
    transition-delay: 0.55s;
  }

  .menu__btn:hover .menu .menu__item:nth-child(4) {
    transition-delay: 0.5s;
  }

  .menu__btn:hover .menu .menu__item:nth-child(5) {
    transition-delay: 0.45s;
  }

  .menu__btn:hover .menu .menu__item:nth-child(6) {
    transition-delay: 0.4s;
  }

  .menu__btn:hover .menu__btn_area:before {
    transition: opacity 0.3s ease-in-out;
    opacity: 1;
  }

  .menu__btn:hover .menu__btn_area:after {
    transition: opacity 0.1s linear 0.3s;
    opacity: 1;
  }

  .menu__list {
    padding: 5px 0;
  }

  .menu__btn {
    display: block;
    cursor: pointer;
    position: relative;
    z-index: 10;
  }

  .menu__btn .menu__btn_area {
    display: block;
    padding: 10px;
    cursor: pointer;
    position: relative;
    z-index: 10;
    text-align: center;
  }

  .menu__btn .menu__btn_area svg {
    text-align: center;
    margin: 0 auto;
    position: relative;
    z-index: 15;
  }

  .menu__btn:hover .menu__btn-icon {
    color: #fff;
  }

  .menu__btn .menu__btn_area:before {
    content: '';
    transition: opacity 0.3s ease-in-out 0.6s;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 10px 0 10px 0;
    opacity: 0;
  }

  .menu__btn .menu__btn_area:after {
    content: '';
    transition: opacity 0.1s linear;
    position: absolute;
    opacity: 0;
    width: 28px;
    height: 1px;
    bottom: 0;
    left: 50%;
    margin-left: -14px;
  }

  .menu__btn-icon {
    transition: color 0.15s ease-in-out;
    position: relative;
  }

  .menu__tip {
    transition: opacity 0.2s ease-in-out;
    color: #fff;
    background: #002d52;
    border-radius: 3px;
    font-size: 12px;
    padding: 6px;
    opacity: 0;
    position: absolute;
    left: 100%;
    margin-left: 1px;
    top: 50%;
    white-space: nowrap;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    pointer-events: none;
  }

  .menu__tip:before {
    content: '';
    position: absolute;
    right: 100%;
    top: 50%;
    margin-top: -5px;
    margin-right: -2px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 10px 5px 0;
    border-color: transparent #002d52 transparent transparent;
  }

  .menu__link {
    transition: color 0.2s ease-in-out;
    color: #656970;
    font-size: 16px;
    line-height: 38px;
    display: block;
    position: relative;
    text-decoration: none;
    cursor: pointer;
  }

  .menu__link:hover {
    color: #fff;
  }

  .menu__link:hover + .menu__tip {
    opacity: 1;
  }

  .menu__item {
    text-align: center;
    opacity: 0;
    transition: opacity 0.3s linear, -webkit-transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out, opacity 0.3s linear;
    transition: transform 0.3s ease-in-out, opacity 0.3s linear, -webkit-transform 0.3s ease-in-out;
  }

  .menu__item a {
    display: block;
    text-align: center;
    margin: 5px 0;
  }

  .menu__item a svg {
    width: 25px;
    height: inherit;
    margin: 1px auto 1px;
  }

  .menu__item:nth-child(1) {
    -webkit-transform: translate(0, -100%);
    transform: translate(0, -100%);
  }

  .menu__item:nth-child(2) {
    -webkit-transform: translate(0, -200%);
    transform: translate(0, -200%);
    transition-delay: 0.05s;
  }

  .menu__item:nth-child(3) {
    -webkit-transform: translate(0, -300%);
    transform: translate(0, -300%);
    transition-delay: 0.1s;
  }

  .menu__item:nth-child(4) {
    -webkit-transform: translate(0, -400%);
    transform: translate(0, -400%);
    transition-delay: 0.15s;
  }

  .menu__item:nth-child(5) {
    -webkit-transform: translate(0, -500%);
    transform: translate(0, -500%);
    transition-delay: 0.2s;
  }

  .menu__item:nth-child(6) {
    -webkit-transform: translate(0, -600%);
    transform: translate(0, -600%);
    transition-delay: 0.25s;
  }
</style>
